import { OrderDirection } from '../../../graphql/schema/types/order-direction'
import { ThisConnector } from '../../connector'
import { normalizeProtectRule, setExpandWithSkipLinks } from '../shared'
import { ContrastQueryParameters } from '../../../graphql/schema/endpoint-helpers'
import { ProtectRule } from '../../../components/protect-rules'

export type SortName = 'name'

export interface OrderBy {
  direction: OrderDirection
  field: SortName
}

export interface ProtectRulesParams {
  expand?: string
  q?: string
  quickFilter?: string
  orderBy?: OrderBy
}

export interface ProtectRulesQueryArgs extends ProtectRulesParams {
  organizationUuid: string
}

export async function getProtectRulesSummary(
  this: ThisConnector,
  { organizationUuid, expand, quickFilter, orderBy, q }: ProtectRulesQueryArgs
): Promise<ProtectRule[]> {
  const urlParams = setUrlParams({ expand, quickFilter, orderBy, q })

  const { rules } = await this.connector.get(
    `/${organizationUuid}/protection/rules/rules?${urlParams}`
  )

  return rules.map(normalizeProtectRule)
}

export function setUrlParams({
  expand,
  quickFilter,
  orderBy,
  q
}: ProtectRulesParams): string {
  const contrastParams = new ContrastQueryParameters()
  contrastParams.append('expand', setExpandWithSkipLinks(expand))
  if (quickFilter) {
    contrastParams.append('quickFilter', quickFilter)
  }
  if (q) {
    contrastParams.append('q', q)
  }
  if (orderBy) {
    contrastParams.append(
      'sort',
      `${orderBy.direction === 'DESC' ? '-' : ''}${orderBy.field}`
    )
  }
  return `${contrastParams}`
}
